import getInfoBarMessageIdsInReadingPane from './getInfoBarMessageIdsInReadingPane';
import addInfoBarMessageInReadingPane from '../actions/addInfoBarMessageInReadingPane';
import removeInfoBarMessageInReadingPane from '../actions/removeInfoBarMessageInReadingPane';
var infoBarAddHandler = function (viewState) { return function (messageId, infoBarMessageViewStateCreator) {
    addInfoBarMessageInReadingPane(viewState, messageId, infoBarMessageViewStateCreator);
}; };
var infoBarRemoveHandler = function (viewState) { return function (messageId) {
    removeInfoBarMessageInReadingPane(viewState, messageId);
}; };
var infoBarGetIdsHandler = function (viewState) { return function () {
    return getInfoBarMessageIdsInReadingPane(viewState);
}; };
export { infoBarAddHandler, infoBarRemoveHandler, infoBarGetIdsHandler };
//# sourceMappingURL=infoBarHandlers.js.map